<template>
	<div class="full-height resetPassContainers">
		<div class="childresetContainer signupMainContainer">
			
			<!-- <div class="signUpcontainer row">
				   <div v-if="showBadEmailError" class="signUperror col-lg-12 col-md-12 col-sm-12">
                        <div class="d-flex flex-column full-height justify-center items-center">
                            <div class="erroricon"><i class="fal fa-exclamation-circle text-error"></i></div>
							<div class="text-font xxlg--text q-pb-xs">{{serviceProvider.email}}</div>
							<div class="errortext">{{badEmailError}}, please try again with a different email. </div>
                            <div class="q-mt-xl">
                                <q-btn @click="onClickReloadPage()"  color="secondaryAlt" text-color="white" unelevated
                                                       class="signupBtn q-px-lg">
                                                    <span>CLOSE</span>
                                                </q-btn>
                            </div>
                        </div>
                </div> 
				<div v-if="!showBadEmailError" class="signUpImage col-lg-6 col-md-6 col-sm-12">
					<div class="d-flex flex-column full-height">
						<div class="goreloLogo text-center hidden mobileView paddingMobileTable">
							<svg width="93" height="125" viewBox="0 0 93 125" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M17.7776 47.0623L6.89453 57.9453L28.9633 80.0141L39.8463 69.1311L17.7776 47.0623Z" fill="#F19100" />
								<path fill-rule="evenodd" clip-rule="evenodd" d="M28.9639 80.0156L6.89453 57.9462L17.7772 47.0635L28.9639 80.0156Z" fill="#E8302D" />
								<path d="M29.8749 45.8561C29.1608 46.5715 28.3126 47.139 27.3789 47.5262C26.4452 47.9135 25.4443 48.1128 24.4335 48.1128C23.4227 48.1128 22.4218 47.9135 21.4882 47.5262C20.5545 47.139 19.7063 46.5715 18.9922 45.8561L63.124 90.0002L74.0085 79.1175L29.8749 34.9717C30.5905 35.6858 31.1583 36.5341 31.5456 37.468C31.933 38.4018 32.1324 39.4029 32.1324 40.4139C32.1324 41.4249 31.933 42.426 31.5456 43.3598C31.1583 44.2937 30.5905 45.142 29.8749 45.8561Z" fill="#E81D76" />
								<path d="M29.8749 45.8561C29.1608 46.5715 28.3126 47.139 27.3789 47.5262C26.4452 47.9135 25.4443 48.1128 24.4335 48.1128C23.4227 48.1128 22.4218 47.9135 21.4882 47.5262C20.5545 47.139 19.7063 46.5715 18.9922 45.8561L34.6312 61.4952L74.0085 79.1105L29.8749 34.9717C30.5905 35.6858 31.1583 36.5341 31.5456 37.468C31.933 38.4018 32.1324 39.4029 32.1324 40.4139C32.1324 41.4249 31.933 42.426 31.5456 43.3598C31.1583 44.2937 30.5905 45.142 29.8749 45.8561Z" fill="#981F5C" />
								<path d="M75.2248 67.0187C75.9389 66.3031 76.7872 65.7353 77.721 65.3479C78.6549 64.9606 79.656 64.7612 80.667 64.7612C81.678 64.7612 82.6791 64.9606 83.6129 65.3479C84.5468 65.7353 85.3951 66.3031 86.1092 67.0187L41.9704 22.8799L31.0859 33.7643L75.2248 77.9014C74.5094 77.1873 73.9419 76.3391 73.5546 75.4054C73.1674 74.4717 72.9681 73.4709 72.9681 72.4601C72.9681 71.4493 73.1674 70.4484 73.5546 69.5147C73.9419 68.581 74.5094 67.7328 75.2248 67.0187Z" fill="#AEC516" />
								<path d="M41.9647 22.8779L31.082 33.7606L62.3601 65.0387L41.9647 22.8779Z" fill="#6AB425" />
								<path fill-rule="evenodd" clip-rule="evenodd" d="M63.5192 41.8795C68.6268 44.6543 74.0262 45.5367 79.3068 42.3949C79.9725 42.0543 80.5639 41.5847 81.0466 41.0134C81.5293 40.4422 81.8936 39.7808 82.1185 39.0675C82.3433 38.3543 82.4242 37.6035 82.3564 36.8587C82.2886 36.1139 82.0734 35.3901 81.7234 34.7292C80.7204 32.1728 78.9433 28.8929 76.2087 27.9651C73.4129 27.0215 70.6031 28.3146 71.0801 29.363C71.6043 32.4803 66.5806 32.1256 67.6919 27.9196C67.8679 27.3247 68.1809 26.7793 68.6057 26.3271C69.0305 25.875 69.5554 25.5287 70.1383 25.316C71.2483 24.8711 72.4288 24.6279 73.6243 24.5979C75.9423 24.5185 78.2565 24.8425 80.4635 25.5554C80.9916 25.2604 81.4127 24.8058 81.6666 24.2569C81.9205 23.7079 81.9942 23.0927 81.8772 22.4993C81.1922 17.2571 64.0801 6.99127 64.973 0L43.1797 21.6675L63.5192 41.8795Z" fill="#8AEFDD" />
								<path fill-rule="evenodd" clip-rule="evenodd" d="M64.9652 0.00195312L43.1719 21.6695L63.5201 41.8797C53.7546 29.2496 54.2363 15.2904 64.9652 0.00195312Z" fill="#71D0BB" />
								<path d="M10.336 105.28C8.88533 105.28 7.75467 105.835 6.944 106.944C6.15467 108.053 5.76 109.984 5.76 112.736C5.76 118.005 7.21067 120.64 10.112 120.64C11.264 120.64 12.288 120.459 13.184 120.096V116.48C12.2027 116.16 11.5307 115.765 11.168 115.296L11.488 112.768H18.976L19.296 115.296C19.0187 115.637 18.5173 115.968 17.792 116.288V122.208C16.768 122.955 15.6373 123.488 14.4 123.808C13.184 124.107 11.6587 124.256 9.824 124.256C6.77333 124.256 4.53333 123.392 3.104 121.664C1.67467 119.915 0.96 117.088 0.96 113.184C0.96 109.259 1.80267 106.357 3.488 104.48C5.19467 102.603 7.52 101.664 10.464 101.664C13.4293 101.664 15.8507 102.336 17.728 103.68C17.728 103.808 17.728 104.053 17.728 104.416C17.728 104.779 17.6533 105.397 17.504 106.272C17.3547 107.147 17.1413 107.861 16.864 108.416H13.92C13.6 107.819 13.3867 106.933 13.28 105.76C12.3627 105.44 11.3813 105.28 10.336 105.28ZM28.3877 124.256C25.8704 124.256 24.0038 123.584 22.7877 122.24C21.5717 120.896 20.9637 118.869 20.9637 116.16C20.9637 113.429 21.6357 111.349 22.9797 109.92C24.3451 108.469 26.2971 107.744 28.8358 107.744C31.3744 107.744 33.2518 108.384 34.4678 109.664C35.7051 110.944 36.3237 112.949 36.3237 115.68C36.3237 118.389 35.6304 120.501 34.2438 122.016C32.8784 123.509 30.9264 124.256 28.3877 124.256ZM25.5718 115.872C25.5718 119.285 26.5958 120.992 28.6438 120.992C29.6891 120.992 30.4571 120.608 30.9478 119.84C31.4598 119.051 31.7158 117.771 31.7158 116C31.7158 112.672 30.6704 111.008 28.5798 111.008C27.5557 111.008 26.7984 111.381 26.3077 112.128C25.8171 112.853 25.5718 114.101 25.5718 115.872ZM47.8845 111.936C46.2632 111.936 45.1432 112.245 44.5245 112.864V120.192C46.2525 120.512 47.4365 120.96 48.0765 121.536L47.7565 124H38.6045L38.2845 121.536C38.5832 121.131 39.1698 120.768 40.0445 120.448V111.552C39.2978 111.296 38.7112 110.933 38.2845 110.464L38.6045 108C39.7778 107.744 40.8338 107.616 41.7725 107.616C42.7112 107.616 43.4898 107.637 44.1085 107.68V109.696C44.5992 109.12 45.2285 108.651 45.9965 108.288C46.7645 107.904 47.4578 107.712 48.0765 107.712C48.7165 107.712 49.1538 107.765 49.3885 107.872L49.2925 112.032C48.8658 111.968 48.3965 111.936 47.8845 111.936ZM58.6907 124.256C56.1307 124.256 54.2001 123.573 52.8987 122.208C51.6187 120.843 50.9787 118.859 50.9787 116.256C50.9787 114.677 51.2027 113.323 51.6507 112.192C52.0987 111.04 52.7067 110.155 53.4747 109.536C54.9681 108.341 56.7067 107.744 58.6907 107.744C60.6747 107.744 62.1894 108.256 63.2347 109.28C64.3014 110.283 64.8348 112.096 64.8348 114.72C64.8348 116.256 64.0774 117.024 62.5627 117.024H55.6187C55.7041 118.368 56.0454 119.317 56.6427 119.872C57.2614 120.427 58.2321 120.704 59.5547 120.704C60.2801 120.704 60.9734 120.619 61.6347 120.448C62.2961 120.277 62.7761 120.107 63.0747 119.936L63.5227 119.68L64.4827 122.24C64.3547 122.389 64.1627 122.581 63.9067 122.816C63.6721 123.029 63.0534 123.328 62.0507 123.712C61.0694 124.075 59.9494 124.256 58.6907 124.256ZM60.7067 114.176C60.7494 113.877 60.7708 113.515 60.7708 113.088C60.7708 112.661 60.6001 112.213 60.2587 111.744C59.9174 111.253 59.3201 111.008 58.4667 111.008C57.6347 111.008 56.9947 111.264 56.5467 111.776C56.0987 112.288 55.8001 113.152 55.6507 114.368L60.7067 114.176ZM66.7355 101.28C67.9302 101.003 69.0395 100.864 70.0635 100.864C71.0875 100.864 71.9515 100.896 72.6555 100.96V120.448C73.4875 120.768 74.0742 121.131 74.4155 121.536L74.0955 124H66.7355L66.4155 121.536C66.7142 121.131 67.3008 120.768 68.1755 120.448V104.832C67.4288 104.576 66.8422 104.213 66.4155 103.744L66.7355 101.28ZM83.449 124.256C80.9317 124.256 79.065 123.584 77.849 122.24C76.633 120.896 76.025 118.869 76.025 116.16C76.025 113.429 76.697 111.349 78.041 109.92C79.4063 108.469 81.3583 107.744 83.897 107.744C86.4357 107.744 88.313 108.384 89.529 109.664C90.7663 110.944 91.385 112.949 91.385 115.68C91.385 118.389 90.6917 120.501 89.305 122.016C87.9397 123.509 85.9877 124.256 83.449 124.256ZM80.633 115.872C80.633 119.285 81.657 120.992 83.705 120.992C84.7503 120.992 85.5183 120.608 86.009 119.84C86.521 119.051 86.777 117.771 86.777 116C86.777 112.672 85.7317 111.008 83.641 111.008C82.617 111.008 81.8597 111.381 81.369 112.128C80.8783 112.853 80.633 114.101 80.633 115.872Z" fill="white" />
							</svg>

						</div>
						<div v-show="signupStep === 1" class="marginBottom paddingMobileTable">
							<p class="fw-400">STEP 1 OF 2</p>
							<h1>Welcome!</h1>
							<p>Sign up to start your IT journey and experience a simpler way to manage technology.</p>
						</div>
						 <div v-show="signupStep === 2" class="marginBottom paddingMobileTable">
							<p class="fw-400">STEP 2 OF 2</p>
							<h1>Verify you're real</h1>
							<p>We use a quick SMS check to keep fake sign-ups and abuse out of Gorelo so the platform stays fast and safe for real MSPs.</p>
						</div> -->
						<!--<img src="@/common/images/singupSideImage.png" />-->
						<!-- <div class="full-height text-right signupMainImage">

							<img src="/mainImage.svg"/>
						</div>

					</div>
				</div>
				
				<div v-show="!isSignupCompleted && !isUnderReview && !showBadEmailError" class="resetSubContainer col-lg-6 col-md-6 col-sm-12 full-height">
					<div class="row items-center content-start justify-center">
						<div class="col-12">
							<form @submit.prevent="signupFormSubmit" class="contact-form">
								<div class="row">
									<div class="col-12 text-center">
										<div class="goreloLogo text-center hidden desktopView">
											<svg width="93" height="125" viewBox="0 0 93 125" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M17.7776 47.0623L6.89453 57.9453L28.9633 80.0141L39.8463 69.1311L17.7776 47.0623Z" fill="#F19100" />
												<path fill-rule="evenodd" clip-rule="evenodd" d="M28.9639 80.0156L6.89453 57.9462L17.7772 47.0635L28.9639 80.0156Z" fill="#E8302D" />
												<path d="M29.8749 45.8561C29.1608 46.5715 28.3126 47.139 27.3789 47.5262C26.4452 47.9135 25.4443 48.1128 24.4335 48.1128C23.4227 48.1128 22.4218 47.9135 21.4882 47.5262C20.5545 47.139 19.7063 46.5715 18.9922 45.8561L63.124 90.0002L74.0085 79.1175L29.8749 34.9717C30.5905 35.6858 31.1583 36.5341 31.5456 37.468C31.933 38.4018 32.1324 39.4029 32.1324 40.4139C32.1324 41.4249 31.933 42.426 31.5456 43.3598C31.1583 44.2937 30.5905 45.142 29.8749 45.8561Z" fill="#E81D76" />
												<path d="M29.8749 45.8561C29.1608 46.5715 28.3126 47.139 27.3789 47.5262C26.4452 47.9135 25.4443 48.1128 24.4335 48.1128C23.4227 48.1128 22.4218 47.9135 21.4882 47.5262C20.5545 47.139 19.7063 46.5715 18.9922 45.8561L34.6312 61.4952L74.0085 79.1105L29.8749 34.9717C30.5905 35.6858 31.1583 36.5341 31.5456 37.468C31.933 38.4018 32.1324 39.4029 32.1324 40.4139C32.1324 41.4249 31.933 42.426 31.5456 43.3598C31.1583 44.2937 30.5905 45.142 29.8749 45.8561Z" fill="#981F5C" />
												<path d="M75.2248 67.0187C75.9389 66.3031 76.7872 65.7353 77.721 65.3479C78.6549 64.9606 79.656 64.7612 80.667 64.7612C81.678 64.7612 82.6791 64.9606 83.6129 65.3479C84.5468 65.7353 85.3951 66.3031 86.1092 67.0187L41.9704 22.8799L31.0859 33.7643L75.2248 77.9014C74.5094 77.1873 73.9419 76.3391 73.5546 75.4054C73.1674 74.4717 72.9681 73.4709 72.9681 72.4601C72.9681 71.4493 73.1674 70.4484 73.5546 69.5147C73.9419 68.581 74.5094 67.7328 75.2248 67.0187Z" fill="#AEC516" />
												<path d="M41.9647 22.8779L31.082 33.7606L62.3601 65.0387L41.9647 22.8779Z" fill="#6AB425" />
												<path fill-rule="evenodd" clip-rule="evenodd" d="M63.5192 41.8795C68.6268 44.6543 74.0262 45.5367 79.3068 42.3949C79.9725 42.0543 80.5639 41.5847 81.0466 41.0134C81.5293 40.4422 81.8936 39.7808 82.1185 39.0675C82.3433 38.3543 82.4242 37.6035 82.3564 36.8587C82.2886 36.1139 82.0734 35.3901 81.7234 34.7292C80.7204 32.1728 78.9433 28.8929 76.2087 27.9651C73.4129 27.0215 70.6031 28.3146 71.0801 29.363C71.6043 32.4803 66.5806 32.1256 67.6919 27.9196C67.8679 27.3247 68.1809 26.7793 68.6057 26.3271C69.0305 25.875 69.5554 25.5287 70.1383 25.316C71.2483 24.8711 72.4288 24.6279 73.6243 24.5979C75.9423 24.5185 78.2565 24.8425 80.4635 25.5554C80.9916 25.2604 81.4127 24.8058 81.6666 24.2569C81.9205 23.7079 81.9942 23.0927 81.8772 22.4993C81.1922 17.2571 64.0801 6.99127 64.973 0L43.1797 21.6675L63.5192 41.8795Z" fill="#8AEFDD" />
												<path fill-rule="evenodd" clip-rule="evenodd" d="M64.9652 0.00195312L43.1719 21.6695L63.5201 41.8797C53.7546 29.2496 54.2363 15.2904 64.9652 0.00195312Z" fill="#71D0BB" />
												<path d="M10.336 105.28C8.88533 105.28 7.75467 105.835 6.944 106.944C6.15467 108.053 5.76 109.984 5.76 112.736C5.76 118.005 7.21067 120.64 10.112 120.64C11.264 120.64 12.288 120.459 13.184 120.096V116.48C12.2027 116.16 11.5307 115.765 11.168 115.296L11.488 112.768H18.976L19.296 115.296C19.0187 115.637 18.5173 115.968 17.792 116.288V122.208C16.768 122.955 15.6373 123.488 14.4 123.808C13.184 124.107 11.6587 124.256 9.824 124.256C6.77333 124.256 4.53333 123.392 3.104 121.664C1.67467 119.915 0.96 117.088 0.96 113.184C0.96 109.259 1.80267 106.357 3.488 104.48C5.19467 102.603 7.52 101.664 10.464 101.664C13.4293 101.664 15.8507 102.336 17.728 103.68C17.728 103.808 17.728 104.053 17.728 104.416C17.728 104.779 17.6533 105.397 17.504 106.272C17.3547 107.147 17.1413 107.861 16.864 108.416H13.92C13.6 107.819 13.3867 106.933 13.28 105.76C12.3627 105.44 11.3813 105.28 10.336 105.28ZM28.3877 124.256C25.8704 124.256 24.0038 123.584 22.7877 122.24C21.5717 120.896 20.9637 118.869 20.9637 116.16C20.9637 113.429 21.6357 111.349 22.9797 109.92C24.3451 108.469 26.2971 107.744 28.8358 107.744C31.3744 107.744 33.2518 108.384 34.4678 109.664C35.7051 110.944 36.3237 112.949 36.3237 115.68C36.3237 118.389 35.6304 120.501 34.2438 122.016C32.8784 123.509 30.9264 124.256 28.3877 124.256ZM25.5718 115.872C25.5718 119.285 26.5958 120.992 28.6438 120.992C29.6891 120.992 30.4571 120.608 30.9478 119.84C31.4598 119.051 31.7158 117.771 31.7158 116C31.7158 112.672 30.6704 111.008 28.5798 111.008C27.5557 111.008 26.7984 111.381 26.3077 112.128C25.8171 112.853 25.5718 114.101 25.5718 115.872ZM47.8845 111.936C46.2632 111.936 45.1432 112.245 44.5245 112.864V120.192C46.2525 120.512 47.4365 120.96 48.0765 121.536L47.7565 124H38.6045L38.2845 121.536C38.5832 121.131 39.1698 120.768 40.0445 120.448V111.552C39.2978 111.296 38.7112 110.933 38.2845 110.464L38.6045 108C39.7778 107.744 40.8338 107.616 41.7725 107.616C42.7112 107.616 43.4898 107.637 44.1085 107.68V109.696C44.5992 109.12 45.2285 108.651 45.9965 108.288C46.7645 107.904 47.4578 107.712 48.0765 107.712C48.7165 107.712 49.1538 107.765 49.3885 107.872L49.2925 112.032C48.8658 111.968 48.3965 111.936 47.8845 111.936ZM58.6907 124.256C56.1307 124.256 54.2001 123.573 52.8987 122.208C51.6187 120.843 50.9787 118.859 50.9787 116.256C50.9787 114.677 51.2027 113.323 51.6507 112.192C52.0987 111.04 52.7067 110.155 53.4747 109.536C54.9681 108.341 56.7067 107.744 58.6907 107.744C60.6747 107.744 62.1894 108.256 63.2347 109.28C64.3014 110.283 64.8348 112.096 64.8348 114.72C64.8348 116.256 64.0774 117.024 62.5627 117.024H55.6187C55.7041 118.368 56.0454 119.317 56.6427 119.872C57.2614 120.427 58.2321 120.704 59.5547 120.704C60.2801 120.704 60.9734 120.619 61.6347 120.448C62.2961 120.277 62.7761 120.107 63.0747 119.936L63.5227 119.68L64.4827 122.24C64.3547 122.389 64.1627 122.581 63.9067 122.816C63.6721 123.029 63.0534 123.328 62.0507 123.712C61.0694 124.075 59.9494 124.256 58.6907 124.256ZM60.7067 114.176C60.7494 113.877 60.7708 113.515 60.7708 113.088C60.7708 112.661 60.6001 112.213 60.2587 111.744C59.9174 111.253 59.3201 111.008 58.4667 111.008C57.6347 111.008 56.9947 111.264 56.5467 111.776C56.0987 112.288 55.8001 113.152 55.6507 114.368L60.7067 114.176ZM66.7355 101.28C67.9302 101.003 69.0395 100.864 70.0635 100.864C71.0875 100.864 71.9515 100.896 72.6555 100.96V120.448C73.4875 120.768 74.0742 121.131 74.4155 121.536L74.0955 124H66.7355L66.4155 121.536C66.7142 121.131 67.3008 120.768 68.1755 120.448V104.832C67.4288 104.576 66.8422 104.213 66.4155 103.744L66.7355 101.28ZM83.449 124.256C80.9317 124.256 79.065 123.584 77.849 122.24C76.633 120.896 76.025 118.869 76.025 116.16C76.025 113.429 76.697 111.349 78.041 109.92C79.4063 108.469 81.3583 107.744 83.897 107.744C86.4357 107.744 88.313 108.384 89.529 109.664C90.7663 110.944 91.385 112.949 91.385 115.68C91.385 118.389 90.6917 120.501 89.305 122.016C87.9397 123.509 85.9877 124.256 83.449 124.256ZM80.633 115.872C80.633 119.285 81.657 120.992 83.705 120.992C84.7503 120.992 85.5183 120.608 86.009 119.84C86.521 119.051 86.777 117.771 86.777 116C86.777 112.672 85.7317 111.008 83.641 111.008C82.617 111.008 81.8597 111.381 81.369 112.128C80.8783 112.853 80.633 114.101 80.633 115.872Z" fill="white" />
											</svg>

										</div>
									</div>

									<div v-show="signupStep === 1" class="row"> 
										<div class="relative-position col-12 newPasswordField q-pt-xs q-pb-16">
										<div class="requiredField relative-position">
											<label class="resetfieldLabel">Organization Name</label>
											<q-input standout dense input-class="text-font" autocomplete="off" class="resetInputField" 
													 @blur="touchValidation('serviceProviderName')"
													 :class="{validationError: isServiceProviderNameInvalid}"
													 bg-color="secondaryAlt" v-model="serviceProvider.serviceProviderName">
											</q-input>

											<div class="text-error absolute right-0"
												 v-if="isServiceProviderNameInvalid">
												{{ $t("lang.components.errorText.etItems.required") }}
											</div>
										</div>
									</div>

									<div class="relative-position col-12 timeZoneField q-pb-16">
										<div class="requiredField relative-position">
											<label class="resetfieldLabel">Time Zone</label>
											<q-select standout bg-color="secondaryAlt"
													  input-class="text-font" dense
													  v-model="serviceProvider.timeZone"
													  :options="timeZoneList"
													  option-label="nameWithZone"
													  option-value="value"
													  emit-value
													  map-options options-selected-class="text-tertiary"
													  :class="{validationError: isTimeZoneInvalid}"
													  dropdown-icon="far fa-chevron-down  xlg--text"
													  @blur="touchValidation('timeZone')">
												<template v-slot:append>
													<q-avatar class="globeAvatar">
														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
															<path d="M12 20.125C12.2891 20.125 13.0547 19.8438 13.8594 18.2344C14.2031 17.543 14.5 16.7031 14.7188 15.75H9.28125C9.5 16.7031 9.79687 17.543 10.1406 18.2344C10.9453 19.8438 11.7109 20.125 12 20.125ZM8.97266 13.875H15.0273C15.0898 13.2773 15.125 12.6484 15.125 12C15.125 11.3516 15.0898 10.7227 15.0273 10.125H8.97266C8.91016 10.7227 8.875 11.3516 8.875 12C8.875 12.6484 8.91016 13.2773 8.97266 13.875ZM9.28125 8.25H14.7188C14.5 7.29688 14.2031 6.45703 13.8594 5.76562C13.0547 4.15625 12.2891 3.875 12 3.875C11.7109 3.875 10.9453 4.15625 10.1406 5.76562C9.79687 6.45703 9.5 7.29688 9.28125 8.25ZM16.9102 10.125C16.9688 10.7305 16.9961 11.3594 16.9961 12C16.9961 12.6406 16.9648 13.2695 16.9102 13.875H19.9062C20.0469 13.2734 20.125 12.6445 20.125 12C20.125 11.3555 20.0508 10.7266 19.9062 10.125H16.9102ZM19.207 8.25C18.3711 6.64453 17.0156 5.35547 15.3633 4.60156C15.9141 5.60156 16.3516 6.84766 16.6367 8.25H19.2109H19.207ZM7.35938 8.25C7.64453 6.84766 8.08203 5.60547 8.63281 4.60156C6.98047 5.35547 5.625 6.64453 4.78906 8.25H7.36328H7.35938ZM4.09375 10.125C3.95312 10.7266 3.875 11.3555 3.875 12C3.875 12.6445 3.94922 13.2734 4.09375 13.875H7.08984C7.03125 13.2695 7.00391 12.6406 7.00391 12C7.00391 11.3594 7.03516 10.7305 7.08984 10.125H4.09375ZM15.3633 19.3984C17.0156 18.6445 18.3711 17.3555 19.207 15.75H16.6328C16.3477 17.1523 15.9102 18.3945 15.3594 19.3984H15.3633ZM8.63672 19.3984C8.08594 18.3984 7.64844 17.1523 7.36328 15.75H4.78906C5.625 17.3555 6.98047 18.6445 8.63281 19.3984H8.63672ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22Z" fill="#C6C7C9" />
														</svg>
													</q-avatar>
												</template>
											</q-select>

											<div class="text-error absolute right-0"
												 v-if="isTimeZoneInvalid">
												{{ $t("lang.components.errorText.etItems.required") }}
											</div>
										</div>
									</div>

									<div class="col-12">
										<div class="row">
											<div class="col-lg-6 col-md-6 col-sm-6 col-12 q-pr-sm relative-position q-pb-16">
												<label class="resetfieldLabel">First Name</label>
												<q-input standout dense input-class="text-font" autocomplete="off" class="resetInputField"
														 bg-color="secondaryAlt"
														 :class="{validationError: isFirstNameInvalid}"
														 @blur="touchValidation('firstName')"
														 v-model="serviceProvider.firstName">
												</q-input>
												<div class="text-error absolute right-0 q-mr-sm"
													 v-if="isFirstNameInvalid">
													{{ $t("lang.components.errorText.etItems.required") }}
												</div>
											</div>
											<div class="col-lg-6 col-md-6 col-sm-6 col-12 q-pl-sm relative-position q-pb-16">
												<label class="resetfieldLabel">Last Name</label>
												<q-input dense standout input-class="text-font" autocomplete="off" class="resetInputField"
														 bg-color="secondaryAlt"
														 :class="{validationError: isLastNameInvalid}"
														 @blur="touchValidation('lastName')"
														 v-model="serviceProvider.lastName">
												</q-input>
												<div class="text-error absolute right-0"
													 v-if="isLastNameInvalid">
													{{ $t("lang.components.errorText.etItems.required") }}
												</div>
											</div>
										</div>
									</div>

									<div class="col-12 q-pb-16 relative-position">
										<label class="resetfieldLabel">Email Address</label>
										<q-input standout input-class="text-font" dense type="email" autocomplete="off" 
												 class="resetInputField"
												 :class="{'validationError': showRequiredValidationErrorForEmail || showEmailValidationErrorForEmail || showEmailStandardValidationErrorForEmail}"
												 bg-color="secondaryAlt"
												 @blur="touchValidation('email')"
												 v-model="serviceProvider.email">
										</q-input>
										<div class="text-error absolute right-0"
											 v-if="showRequiredValidationErrorForEmail">
											{{ $t("lang.components.errorText.etItems.required") }}
										</div>
										<div class="text-error absolute right-0"
											 v-else-if="showEmailValidationErrorForEmail || showEmailStandardValidationErrorForEmail">
											Invalid email
										</div>
									</div>

									<div class="col-lg-6 col-md-6 col-sm-6 col-12 q-pb-16 serviceProviderRadio q-pr-sm">
										<label class="resetfieldLabel">
											Organization Type
											<span class="serviceInfo">
												<i class="far fa-info-circle cursor-Pointer"></i>
												<q-tooltip transition-show="none" transition-hide="none"
														   max-width="400px" anchor="top middle" self="bottom middle">
													<span class="md--text fw-600">
														Managed Service Provider:
													</span>
													<span class="md--text">
														Manage multiple businesses.
													</span><br />
													<span class="md--text fw-600">
														Enterprise:
													</span>
													<span class="md--text">
														Oversee various departments.
													</span>
													<span class="md--text">
														Choosing <span class="md--text fw-600">Enterprise</span> will remove billing components such as products, contracts, invoices and more.
													</span>
												</q-tooltip>
											</span>
										</label>
										<q-select v-model="serviceProvider.serviceProviderType" :options="serviceProviderTypeOptions"
												  standout bg-color="secondaryAlt"
												  input-class="text-font" dense
												  option-label="text"
												  option-value="value"
												  emit-value options-selected-class="text-tertiary"
												  map-options
												  dropdown-icon="far fa-chevron-down  xlg--text">

											<template v-slot:selected-item="scope">
												<div class="row items-center q-my-none">
													<div class="col-auto q-pr-sm">
														<span>
															<q-icon name="app:housebuildingduotone" class="xxlg--text" v-if="scope.opt.value === 1" />
															<q-icon name="app:buildingduotonesolid" class="xxlg--text" v-if="scope.opt.value === 2" />
														</span>
													</div>
													<div class="col">
														<span>
															{{scope.opt.text}}
														</span>
													</div>
												</div>
											</template>

											<template v-slot:option="scope">
												<q-item v-bind="scope.itemProps">
													<q-item-section avatar class="q-pr-sm min-wd-28">
														<q-icon name="app:housebuildingduotonesolid" v-if="scope.opt.value === 1" />
														<q-icon name="app:buildingduotone" v-if="scope.opt.value === 2" />

													</q-item-section>
													<q-item-section>
														<q-item-label>{{scope.opt.text}}</q-item-label>
													</q-item-section>
												</q-item>
											</template>

										</q-select> -->

										<!-- <label class="resetfieldLabel">
											Organization Type
											<span class="serviceInfo">
												<i class="far fa-info-circle cursor-Pointer"></i>
												<q-tooltip transition-show="none" transition-hide="none"
														   max-width="400px" anchor="top middle" self="bottom middle">
													<span class="md--text fw-600">
														Managed Service Provider:
													</span>
													<span class="md--text">
														Manage multiple businesses.
													</span><br />
													<span class="md--text fw-600">
														Enterprise:
													</span>
													<span class="md--text">
														Oversee various departments.
													</span>
													<span class="md--text">
														Choosing <span class="md--text fw-600">Enterprise</span> will remove billing components such as products, contracts, invoices and more.
													</span>
												</q-tooltip>
											</span>
										</label> -->
										<!-- <div class="row">
											<div class="col-6 q-pr-sm">
												<q-radio dense v-model="serviceProvider.serviceProviderType" class="mspoption" checked-icon="app:multibuidlingiconduotone" unchecked-icon="app:multibuidlingicon" :val="1" label="Managed Service Provider" />
											</div>
											<div class="col-6 q-pl-sm">
												<q-radio dense v-model="serviceProvider.serviceProviderType" class="enterpriseMSPOption" checked-icon="app:buildingduotonesolid" unchecked-icon="app:buildingduotone" :val="2" label="Enterprise" />
											</div>
										</div> -->
									<!-- </div>

									<div class="col-lg-6 col-md-6 col-sm-6 col-12 q-pb-16 relative-position q-pl-sm">
												<label class="resetfieldLabel">No. of Technicians</label>
												<q-select 
														standout bg-color="secondaryAlt"
													  input-class="text-font" dense
													 v-model="serviceProvider.noOfTechnicians" :options="technicianOptions"
													  option-label="text"
													  option-value="value"
													  emit-value options-selected-class="text-tertiary"
													  map-options
													 :class="{validationError: isTechnicianCountInvalid}"
													  dropdown-icon="far fa-chevron-down  xlg--text"
													  @blur="touchValidation('noOfTechnicians')"
												/>
												<div class="text-error absolute right-0"
													 v-if="isTechnicianCountInvalid">
													{{ $t("lang.components.errorText.etItems.required") }}
												</div>
											</div>

											<div class="col-6 q-pt-xs q-pr-sm" >
												<label class="resetfieldLabel">I will sign in with</label>
												<div class="azurebutton" :class="{validationError: isSignInWithInvalid}">
												
												
													<q-radio  v-model="signInWith" val="azure" @blur="touchValidation('signInWith')" hide-details size="34px" dense color="tertiary" label="Azure AD" />
													<q-tooltip transition-show="none" transition-hide="none"
														max-width="400px" class="md--text" anchor="top middle" self="bottom middle">
													
													Sign in with your Microsoft 365 work account
													
													</q-tooltip>
												</div>
												</div>
												<div class="col-6 q-pt-xs q-pl-sm" >
												<label class="resetfieldLabel text-right">&nbsp;
													
												</label>
												<div class="emailbutton"  :class="{validationError: isSignInWithInvalid}">
												<q-radio v-model="signInWith" val="email" @blur="touchValidation('signInWith')" hide-details size="34px" dense color="tertiary" label="Email" />
												<q-tooltip transition-show="none" transition-hide="none"
														max-width="400px" class="md--text" anchor="top middle" self="bottom middle">
													
													Sign in with your email, password and MFA
													
													</q-tooltip>
												</div>
											</div>
											<div class="text-error col-12 text-right md--text q-pb-md relative-position"
													>
													<span class="absolute right-0"  v-if="isSignInWithInvalid">{{ $t("lang.components.errorText.etItems.required") }}</span>
											</div>

									<div class="col-12">
										<div id="cf-turnstile"
											 class="cf-turnstile text-center"></div>

									</div>

									<div class="col-12 text-center signupbtndiv">
										<div class="row">
											<div class="col-lg-6 col-md-6 col-sm-6 col-12 q-pr-sm q-mb-md">
												<q-btn @click="goToLoginPage()" color="secondaryAlt" text-color="white" unelevated
													   class="signupBtn q-mr-md">
													<span>Back to Sign in</span>
												</q-btn>
											</div>
											<div class="col-lg-6 col-md-6 col-sm-6 col-12 q-pl-sm">
												<q-btn @click="validateAndGoToNextStep()" :disabled="isSubmitting" color="success" text-color="white" unelevated
													   class="signupBtn">
													<span>Next</span>
												</q-btn>
											</div>
										</div>
									</div>
									</div>
									<div v-show="signupStep === 2" class="row mobileverification" >
										<div class="col-12">
											<div class="row">

												<div class="relative-position col-12 newPasswordField q-pt-xs q-pb-16">
													<div class="requiredField relative-position">
														<label class="resetfieldLabel">Mobile Verification</label>
														<div class="row">
															<div class="col q-pr-sm">
																<div class="row bg-secondaryAlt bdr-radius-4">
																	<div class="col-auto min-wd-80">
																		<q-select 
																			v-model="contactCountry"
																			:options="getCountries"
																			@update:model-value="isCellPhoneNumberValid = isNumberValid(cellPhone)"
																			dense option-label="name" standout
																			bg-color="secondaryAlt" color="tertiary"
																			dropdown-icon="fal fa-chevron-down text-font xlg--text" input-class="text-font"
																			for="quick_contact_mobile_countrycode_dropdown_ID">
																			<template v-slot:selected>
																				<div class="row items-center q-my-none">
																					<img :src="contactCountry.image" style="width: 30px" />
																				</div>
																				</template>
																				<template v-slot:option="scope">
																					<q-item v-bind="scope.itemProps">
																						<q-item-section>
																							<div class="row items-center q-ml-xs">
																								<img :src="scope.opt.image" style="width: 30px" />
																								<span class="q-ml-xs">{{ scope.opt.name }} ({{ scope.opt.Iso
																									}})</span>
																							</div>
																						</q-item-section>
																					</q-item>
																				</template>
																		</q-select>
																	</div>
																	<div class="col">
																		<q-input 
																			standout dense input-class="text-font" 
																			placeholder="Phone" autocomplete="off" 
																			class="resetInputField" bg-color="secondaryAlt"
																			v-model="cellPhone" maxlength="60"
																			:class="statusCellPhone()"
																			@update:model-value="isCellPhoneNumberValid = isNumberValid(cellPhone)"
																		>
																		</q-input>
																	</div>
																</div>
															</div>
															<div class="col-auto signupbtndiv">
																<q-btn @click="sendOTPCode" 
																		:disable="!isCellPhoneNumberValid || isCounting" 
																		:loading="isCounting" 
																		color="success" outline unelevated
																		class="sendcodeBtn">
																 	<template v-slot:loading>
																		<span class="text-secondary text-tranform-none">{{ counter }}s</span>
																	</template>
																  	<span class="text-white">
																		{{ isCounting ? 'Send Code' : (counter === 0 ? 'Send Again' : 'Send Code') }}
																	</span>
																</q-btn>
															</div>
														</div>
													</div>
												</div>
												<div class="relative-position col-12 newPasswordField q-pt-xs q-pb-16">
													<div class="requiredField relative-position">
														<q-input 
															v-model="otpCode" :disable="!isOTPSent"
															standout dense input-class="text-font" placeholder="Enter code" 
															autocomplete="off" class="resetInputField" 
															bg-color="secondaryAlt"  maxlength="6" >
														</q-input>
													</div>
												</div>
												<div class="col-12 text-center signupbtndiv q-pt-md ">
													<div class="row">
														<div class="col-lg-6 col-md-6 col-sm-6 col-12 q-pr-sm q-mb-md">
															<q-btn @click="goToPreviousPage()" color="secondaryAlt" text-color="white" unelevated
																class="signupBtn q-mr-md">
																<span>Back</span>
															</q-btn>
														</div>
														<div class="col-lg-6 col-md-6 col-sm-6 col-12 q-pl-sm">
															<q-btn :disable="!isOTPSent || otpCode.length !== 6" type="submit" color="success" text-color="white" unelevated
																class="signupBtn">
																<span>{{isSubmitting? 'Signing Up...':'Sign Up'}}</span>
															</q-btn>
														</div>
													</div>
												</div>
												<div class="relative-position col-12 infotext  q-pt-xs">
													<div class="row">
														<div class="col-auto q-pr-sm">
															<q-icon name="app:infoicon" />
														</div>
														<div class="col">
															 If you're unable to complete SMS verification, contact <b><a href="mailto:help@gorelo.io" target="_blank">help@gorelo.io</a></b> for manual verification.
														</div>
													</div>
												</div>

											</div>
										</div>

										

									</div>

									



									
								</div>

							</form>
						</div>
					</div>
				</div>
				
				<div v-show="isSignupCompleted || isUnderReview" class="resetSubContainer  col-lg-6 col-md-6 col-sm-12 accountSuccess">
					<div class="row items-center content-start justify-center full-height">
						<div class="col-12 full-height">

							<div class="row full-height items-center">
								<div v-if="isSignupCompleted" class="col-12 text-center">
									<div class="goreloLogo text-center q-pb-xl q-mb-sm accountcreateSVG">
										<svg width="220" height="220" viewBox="0 0 220 220" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path opacity="0.4" d="M124.82 6.13115C116.645 -2.04372 103.355 -2.04372 95.1366 6.13115L75.2459 26.0656H47.0492C35.4645 26.0656 26.0656 35.4645 26.0656 47.0492V75.2459L6.13115 95.1803C-2.04372 103.355 -2.04372 116.645 6.13115 124.863L26.0656 144.754L26.0656 172.951C26.0656 184.536 35.4645 193.934 47.0492 193.934H75.2459L95.1803 213.869C103.355 222.044 116.645 222.044 124.863 213.869L144.754 193.934H172.951C184.536 193.934 193.934 184.536 193.934 172.951V144.754L213.869 124.82C222.044 116.645 222.044 103.355 213.869 95.1366L193.934 75.2459V47.0492C193.934 35.4645 184.536 26.0656 172.951 26.0656L144.754 26.0656L124.82 6.13115Z" fill="#26282B" />
											<g clip-path="url(#clip0_343_3497)">
												<path d="M100.427 80.0078C102.248 76.5703 105.858 74.25 110 74.25C114.142 74.25 117.752 76.5703 119.573 80.0078C120.502 81.7609 122.547 82.6031 124.438 82.0187C128.15 80.8844 132.361 81.7781 135.283 84.7172C138.205 87.6562 139.116 91.85 137.981 95.5625C137.397 97.4531 138.239 99.4984 139.992 100.409C143.43 102.231 145.75 105.841 145.75 109.983C145.75 114.125 143.43 117.734 139.992 119.556C138.239 120.484 137.397 122.512 137.981 124.403C139.116 128.116 138.222 132.327 135.283 135.248C132.344 138.17 128.15 139.081 124.438 137.947C122.547 137.363 120.502 138.205 119.591 139.958C117.769 143.395 114.159 145.716 110.017 145.716C105.875 145.716 102.266 143.395 100.444 139.958C99.5156 138.205 97.4875 137.363 95.5969 137.947C91.8844 139.081 87.6734 138.188 84.7516 135.248C81.8297 132.309 80.8844 128.15 82.0187 124.438C82.6031 122.547 81.7609 120.502 80.0078 119.591C76.5703 117.752 74.25 114.142 74.25 110C74.25 105.858 76.5703 102.248 80.0078 100.427C81.7609 99.4984 82.6031 97.4531 82.0187 95.5625C80.8844 91.85 81.7781 87.6391 84.7172 84.7172C87.6562 81.7953 91.85 80.8844 95.5625 82.0187C97.4531 82.6031 99.4984 81.7609 100.409 80.0078H100.427ZM110 66C103.83 66 98.3469 68.9219 94.8578 73.4594C89.1859 72.7203 83.2391 74.525 78.8734 78.8906C74.5078 83.2563 72.7031 89.2031 73.4422 94.875C68.9219 98.3469 66 103.83 66 110C66 116.17 68.9219 121.653 73.4594 125.142C72.7203 130.814 74.525 136.761 78.8906 141.127C83.2563 145.492 89.2031 147.297 94.875 146.558C98.3469 151.078 103.83 154 110 154C116.17 154 121.653 151.078 125.142 146.541C130.814 147.28 136.761 145.475 141.127 141.109C145.492 136.744 147.297 130.797 146.558 125.125C151.078 121.653 154 116.17 154 110C154 103.83 151.078 98.3469 146.541 94.8578C147.28 89.1859 145.475 83.2391 141.109 78.8734C136.744 74.5078 130.797 72.7031 125.125 73.4422C121.653 68.9219 116.17 66 110 66ZM129.422 101.922C131.037 100.306 131.037 97.6938 129.422 96.0953C127.806 94.4969 125.194 94.4797 123.595 96.0953L104.517 115.173L96.4391 107.095C94.8234 105.48 92.2109 105.48 90.6125 107.095C89.0141 108.711 88.9969 111.323 90.6125 112.922L101.612 123.922C103.228 125.537 105.841 125.537 107.439 123.922L129.422 101.922Z" fill="#8BF0DE" />
											</g>
											<defs>
												<clipPath id="clip0_343_3497">
													<rect width="88" height="88" fill="white" transform="translate(66 66)" />
												</clipPath>
											</defs>
										</svg>

									</div>
									<div class="successContent">
										<h3 class="q-ma-none text-center q-pb-sm q-mb-sm">Account created successfully</h3>
										<p class="text-center xlg--text" v-if="!willAccountLoginWithAzureAD">
											Congratulations! Your Gorelo tenant is being prepared. We will email you shortly with the next steps.
										</p>
										<p class="text-center xlg--text" v-else>
											Congratulations! Your Gorelo tenant has been created. Go to sign in page and click on
											"Sign in with Azure AD".
										</p>
									</div>
								</div>

								<div v-if="isUnderReview" class="col-12 text-center">
									<div class="goreloLogo text-center q-pb-xl q-mb-sm accountcreateSVG">
										<svg width="224" height="224" viewBox="0 0 224 224" fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<rect x="25.75" y="25.748" width="172.506" height="172.506" rx="25.7471"
												fill="#2F3237">
											</rect>
											<rect x="112" y="-9.98047" width="172.506" height="172.506" rx="25.7471"
												transform="rotate(45 112 -9.98047)" fill="#2F3237"></rect>
											<path
												d="M83.875 66C80.7637 66 78.25 68.5137 78.25 71.625C78.25 74.7363 80.7637 77.25 83.875 77.25V79.1836C83.875 86.6367 86.8457 93.791 92.1191 99.0645L104.055 111L92.1191 122.936C86.8457 128.209 83.875 135.363 83.875 142.816V144.75C80.7637 144.75 78.25 147.264 78.25 150.375C78.25 153.486 80.7637 156 83.875 156H140.125C143.236 156 145.75 153.486 145.75 150.375C145.75 147.264 143.236 144.75 140.125 144.75V142.816C140.125 135.363 137.154 128.209 131.881 122.936L119.945 111L131.881 99.0645C137.154 93.791 140.125 86.6367 140.125 79.1836V77.25C143.236 77.25 145.75 74.7363 145.75 71.625C145.75 68.5137 143.236 66 140.125 66H83.875ZM95.125 79.1836V77.25H128.875V79.1836C128.875 82.5234 127.891 85.7578 126.062 88.5H97.9375C96.127 85.7578 95.125 82.5234 95.125 79.1836ZM97.9375 133.5C98.5527 132.568 99.2734 131.689 100.064 130.881L112 118.945L123.936 130.881C124.744 131.689 125.447 132.568 126.08 133.5H97.9375Z"
												fill="#8BF0DE"></path>
										</svg>

									</div>
									<div class="successContent">
										<h3 class="q-ma-none text-center q-pb-sm q-mb-sm">Account under review</h3>
										<p class="text-center xlg--text">
											Your Gorelo tenant is currently being prepared and is under a standard
											review process. We’ll
											email you shortly once everything is ready and with next steps.
										</p>
									</div>
								</div>

								<div class="col-12 goreloScheduleCalendy cursor-pointer">
								<div class="row items-center bg-secondaryAlt rounded-borders q-py-sm q-px-md justify-center goreloCalendyArea" @click="openCalendlyLink()">
									<div class="col-auto q-pr-md">
										<q-icon class="xxlg--text" name="fa-solid fa-calendar-days"></q-icon>
									</div>
									<div class="col">
										<div class="lg--text fw-600">
											{{ calendlyTitle }}
										</div>
										<div>{{ calendlySubtitle }}</div>
									</div>
									<div class="col-auto">
										<i class="fa-regular fa-arrow-up-right xlg--text newTabArrow" aria-hidden="true"></i>
									</div>
								</div>
							</div>

								<div class="col-12 text-center backtologindiv">
									<q-btn @click="goToLoginPage()" color="success" text-color="white" class="backloginBtn" unelevated>
										<span>Sign in Now</span>
									</q-btn>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> -->

			<div class="signUpcontainer row signUpDisableContainer">
				<div class="col-lg-12 col-md-12 col-sm-12 signupDisableContent">
                        <div class="disableContent d-flex flex-column full-height justify-center items-center text-center">
                            <div class="disableLogo">
								<i class="fa-kit fa-user-circle-minus-regular"></i>
							</div>
							<div class="text-font xxlg--text q-pb-xs disableHeading fw-600">Signups are temporarily paused</div>
							<div class="disableTextArea q-pb-xs">We're completing our Australia East region migration this weekend. New signups will reopen on Monday 22 June.</div>
                            <div class="disableContact">
								Questions? Contact <a href="mailto:help@gorelo.io">help@gorelo.io</a>.
							</div>
                        </div>
                </div>
			</div>
			
			<div class="copyRightsBar text-center">
				<span class="copyRightContent">
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
						<g clip-path="url(#clip0_178_357)">
							<path d="M9 1.125C11.0886 1.125 13.0916 1.95468 14.5685 3.43153C16.0453 4.90838 16.875 6.91142 16.875 9C16.875 11.0886 16.0453 13.0916 14.5685 14.5685C13.0916 16.0453 11.0886 16.875 9 16.875C6.91142 16.875 4.90838 16.0453 3.43153 14.5685C1.95468 13.0916 1.125 11.0886 1.125 9C1.125 6.91142 1.95468 4.90838 3.43153 3.43153C4.90838 1.95468 6.91142 1.125 9 1.125ZM9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM11.3871 11.3871C10.0687 12.7055 7.93125 12.7055 6.61289 11.3871C5.29453 10.0687 5.29453 7.93125 6.61289 6.61289C7.93125 5.29453 10.0687 5.29453 11.3871 6.61289C11.6051 6.83086 11.9637 6.83086 12.1816 6.61289C12.3996 6.39492 12.3996 6.03633 12.1816 5.81836C10.4238 4.06055 7.57617 4.06055 5.81836 5.81836C4.06055 7.57617 4.06055 10.4238 5.81836 12.1816C7.57617 13.9395 10.4238 13.9395 12.1816 12.1816C12.3996 11.9637 12.3996 11.6051 12.1816 11.3871C11.9637 11.1691 11.6051 11.1691 11.3871 11.3871Z" fill="#C6C7C9" />
						</g>
						<defs>
							<clipPath id="clip0_178_357">
								<rect width="18" height="18" fill="white" />
							</clipPath>
						</defs>
					</svg>
				</span> 2026 All Rights Reserved.
			</div>
		</div>
	</div>
</template>

<script src="./signup.ts"></script>
<style scoped>  
  
</style>
